import { get } from './client';
import { buildPath, toJson } from './utils';
import { GeneralListType, Options } from './types';
import { DEFAULT_META_TAGS } from './constants';
import { DefaultMetaTagDisplay } from './admin/models';

export const getDefaultMetaTags = (options: Options): Promise<GeneralListType<DefaultMetaTagDisplay>> =>
  get(buildPath(DEFAULT_META_TAGS), options).then(toJson);
